const earnTransactionRoutes = [
    {
        path: '/earn-transaction',
        name: 'earnTransactionList',
        component: () => import('@/modules/earn_transaction/list/List.vue'),
        meta: {
            resource: 'earn-transactions',
            action: 'view',
            layout: 'default',
            auth: true,
            title: 'Earn Transaction',
            breadcrumbs: [{ title: 'Earn Transaction', routeName: 'earnTransactionList' }]
        }
    }
]

export default earnTransactionRoutes
